import React from 'react';
import { Background, Content, Header, Icon } from './styles';
import { FaTimes } from 'react-icons/fa';

function Modal({
  icon,
  title,
  handlerClose,
  children,
  width,
  billetWarning,
  confirmData,
}: React.PropsWithChildren<IModal>) {
  const handler = (e: any) => {
    e.target.id === 'background' && handlerClose();
  };

  return (
    <Background id='background' onClick={(e) => handler(e)}>
      <Content
        width={width}
        billetWarning={billetWarning}
        confirmData={confirmData}
      >
        <Header>
          <div className='close' onClick={handlerClose}>
            Fechar
          </div>
          {
            <div className='title'>
              {icon}
              {title}
            </div>
          }
          <div className='ghost' />
          <Icon onClick={handlerClose}>
            <FaTimes style={{ height: 18, width: 16 }} />
          </Icon>
        </Header>
        {children}
      </Content>
    </Background>
  );
}

export default Modal;
